"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generator_hyperspace = exports.getIsInHyperspace = exports.signalHyperspace = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var voyageMessageJump_sidecar_1 = require("@voyage/multi/voyageMessageJump-sidecar");
var voyageBackground_hyper_sidecar_1 = require("@voyage/background/voyageBackground_hyper-sidecar");
var voyageBackground_starfield_sidecar_1 = require("@voyage/background/voyageBackground_starfield-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var _enterTimer = 0;
var _inTimer = 0;
var _exitTimer = 0;
var _enterTime = 2;
var _inTime = 2;
var _exitTime = 2;
var _signalStart = false;
var _isInHyperspace = false;
var signalHyperspace = function () {
    _signalStart = true;
    console.log('Signal hyperspace!!!');
};
exports.signalHyperspace = signalHyperspace;
var getIsInHyperspace = function () {
    return _isInHyperspace;
};
exports.getIsInHyperspace = getIsInHyperspace;
function generator_hyperspace() {
    var ds, ds, ds;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 12];
                if (!!_signalStart) return [3 /*break*/, 2];
                return [4 /*yield*/, 0];
            case 1:
                _a.sent();
                return [3 /*break*/, 0];
            case 2:
                _signalStart = false;
                _isInHyperspace = true;
                voyageBackground_starfield_sidecar_1.voyageBackground_starfield.show(false);
                voyageBackground_hyper_sidecar_1.voyageBackground_hyper.setSpeed(0.001);
                voyageBackground_hyper_sidecar_1.voyageBackground_hyper.reset();
                _enterTimer = 0;
                _a.label = 3;
            case 3:
                if (!true) return [3 /*break*/, 5];
                ds = common_sidecar_1.common.getUpdateDeltaScaled();
                _enterTimer += ds;
                voyageBackground_hyper_sidecar_1.voyageBackground_hyper.setSpeed(_enterTimer / _enterTime);
                // console.log('hyper start', _enterTimer)
                if (_enterTimer >= _enterTime) {
                    return [3 /*break*/, 5];
                }
                return [4 /*yield*/, 0];
            case 4:
                _a.sent();
                return [3 /*break*/, 3];
            case 5:
                _inTimer = 0;
                _a.label = 6;
            case 6:
                if (!true) return [3 /*break*/, 8];
                ds = common_sidecar_1.common.getUpdateDeltaScaled();
                _inTimer += ds;
                voyageBackground_hyper_sidecar_1.voyageBackground_hyper.setSpeed(1);
                if (_inTimer >= _inTime) {
                    return [3 /*break*/, 8];
                }
                return [4 /*yield*/, 0];
            case 7:
                _a.sent();
                return [3 /*break*/, 6];
            case 8:
                _exitTimer = 0;
                _a.label = 9;
            case 9:
                if (!true) return [3 /*break*/, 11];
                ds = common_sidecar_1.common.getUpdateDeltaScaled();
                _exitTimer += ds;
                voyageBackground_hyper_sidecar_1.voyageBackground_hyper.setSpeed(1 - _exitTimer / _exitTime);
                if (_exitTimer >= _exitTime) {
                    return [3 /*break*/, 11];
                }
                return [4 /*yield*/, 0];
            case 10:
                _a.sent();
                return [3 /*break*/, 9];
            case 11:
                voyageBackground_hyper_sidecar_1.voyageBackground_hyper.setSpeed(0);
                _isInHyperspace = false;
                if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
                    voyageMessageJump_sidecar_1.voyageMessageJump.signal_reachedDestination();
                }
                voyageBackground_starfield_sidecar_1.voyageBackground_starfield.show(true);
                voyageBackground_starfield_sidecar_1.voyageBackground_starfield.reset();
                return [3 /*break*/, 0];
            case 12: return [2 /*return*/, 0];
        }
    });
}
exports.generator_hyperspace = generator_hyperspace;
